export const eeoReports = {
  id: 'eeo',
  name: 'EEO',
  description: '',
  visibility: 'private',
  subject_type: 'eeo',
  layout: {
    data: [
      {
        h: 18,
        w: 12,
        x: 0,
        y: 0,
        key: '4829',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
      {
        h: 18,
        w: 12,
        x: 0,
        y: 18,
        key: '4830',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
      {
        h: 28,
        w: 12,
        x: 0,
        y: 36,
        key: '4831',
        maxH: 100,
        maxW: 12,
        minH: 8,
        minW: 8,
      },
    ],
  },
  tiles: [
    {
      id: 4829,
      subject_type: 'eeoc',
      metadata: {
        id: 'eeoc_race_table',
        tileKey: 'eeoc_race_table',
        apiParam: 'visual',
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
        defaultFilters: {
          group_by_1: 'race',
          group_by_2: 'gender',
        },
      },
      query: null,
    },
    {
      id: 4830,
      subject_type: 'eeoc',
      metadata: {
        id: 'eeoc_veteran_table',
        tileKey: 'eeoc_veteran_table',
        apiParam: 'visual',
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
        defaultFilters: {
          group_by_1: 'veteran_status',
          group_by_2: 'gender',
        },
      },
      query: null,
    },
    {
      id: 4831,
      subject_type: 'eeoc',
      metadata: {
        id: 'eeoc_disability_table',
        tileKey: 'eeoc_disability_table',
        apiParam: 'visual',
        headerKeys: [
          'jobs_completed',
          'scorecards_filled',
          'time_to_fill_scorecard',
          'total_interview_duration',
          'applicants_interviewed',
          'strong_yes',
          'yes',
          'strong_no',
          'no',
        ],
        componentType: 'table',
        defaultFilters: {
          group_by_1: 'disability_status',
          group_by_2: 'gender',
        },
      },
      query: null,
    },
  ],
  user: {
    id: null,
  },
};
